module.exports = __webpack_public_path__ + "img/transfer_between_accounts.6662c005.svg";